<style lang="scss" scoped>
    h4 {
        font-size: 22px;

        &::before {
            content: '';
            margin-right: 12px;
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: white;
        }
    }

    h5 {
        font-size: 13px;
    }

    h6 {
        padding-left: 20px;
        font-size: 20px;
    }

    .circle {
        margin-left: 20px;
        width: 100px;
        height: 100px;
        border-radius: 50%;

        section {
            font-size: 20px;
        }
    }

    .circle1 {
        background: rgba(0, 195, 98, 0.3);
        border: 2px solid rgba(0, 195, 98, 0.5);

        section {
            color: rgba(0, 195, 98, 1);
        }
    }

    .circle2 {
        background: rgba(255, 222, 0, 0.3);
        border: 2px solid rgba(255, 222, 0, 0.5);

        section {
            color: rgba(255, 222, 0, 1);
        }
    }

    .circle3 {
        background: rgba(255, 0, 246, 0.3);
        border: 2px solid rgba(255, 0, 246, 0.5);

        section {
            color: rgba(255, 0, 246, 1);
        }
    }

    .circle4 {
        background: rgba(255, 8, 8, 0.3);
        border: 2px solid rgba(255, 8, 8, 0.5);

        section {
            color: rgba(255, 8, 8, 1);
        }
    }

    .list {
        width: (450/1920*100%);
        background: rgba(255, 255, 255, 0.1);
        border: 2px solid rgba(255, 255, 255, 0.5);
        border-radius: 10px;
    }

    li {
        padding: 10px 20px;
        background: rgba(0, 0, 0, 0.5);
        border: 2px solid rgba(255, 255, 255, 0.5);
        border-radius: 10px;
    }
</style>
<template>
    <div class="flex oh column">
        <div class="flex0 flex aic">
            <p class="fs20">
                今日共<span class="color_main">6</span>例急救转诊，<span class="color_main">3</span>例运送中
            </p>
            <div class="circle circle1 flex aic jcc column">
                <h5>平均响应时间</h5>
                <section>{{data.avgResponseTimeDescription}}</section>
            </div>
            <div class="circle circle2 flex aic jcc column">
                <h5>平均接送时间</h5>
                <section>42分</section>
            </div>
            <div class="circle circle3 flex aic jcc column">
                <h5>平均费用</h5>
                <section>4000元</section>
            </div>
            <div class="circle circle4 flex aic jcc column">
                <h5>平均评价</h5>
                <section>9,9分</section>
            </div>
        </div>
        <div class="flex1 flex pb15">
            <div class="map flex1"></div>
            <div class="list flex0 pt15 pb15 pl30 pr30" style="overflow-y: auto">
                <template v-for="(item,index) in list">
                    <h4 :key="'h4'+index" class="flex aic" :class="{pt15:index>0}">
                        {{item.name}}（{{item.list.length}}）</h4>
                    <ul class="pt15 pb15 pl20" v-for="(da,idx) in item.list" :key="'ul'+index+idx">
                        <li class="flex aic pointer" @click="detail(da)">
                            <div class="flex1">
                                <p class="fs18 color_fff">{{da.patName}} {{da.patGender|sexFilter}} {{da.patAge}}岁</p>
                                <section class="mt10 fs24 color_main">{{da.initHosName}} → {{da.hopeHosName}}</section>
                                <div class="mt10 fs16">
                                    {{getEmergencyProcedureRecordsList(da.emergencyProcedureRecordsList)}}
                                </div>
                            </div>
                            <span class="el-icon-arrow-right"></span>
                        </li>
                    </ul>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
  import {staffService} from "../../service/staff";
  import {STAFF_ORDER_STATUS} from "../../config";
  import {sexFilter} from "../../../../common/lib/filters";

  export default {
    name: 'jijiu-daping-today',
    filters: {sexFilter},
    data() {
      return {
        info: {},
        data: {}
      }
    },
    computed: {
      list() {
        const {data} = this;
        const list = data.toDayEmergencyList || [];
        return [...STAFF_ORDER_STATUS].map(r => {
          return {...r, list: [...list].filter(rr => rr.referralStatus === r.id)};
        })
      }
    },
    created() {
      this.getData();
    },
    methods: {
      getEmergencyProcedureRecordsList(list) {
        const item = [...list].pop();
        return item.procedureDescribtion || '';
      },
      async detail(data) {
        Log('data', data);
        this.info = await staffService.detail(data.id);
      },
      async getData() {
        this.data = await staffService.today();
      }
    },
  }
</script>
